import { render } from "./RegisterEvento.vue?vue&type=template&id=eb27e62e&scoped=true&ts=true"
import script from "./RegisterEvento.vue?vue&type=script&lang=ts"
export * from "./RegisterEvento.vue?vue&type=script&lang=ts"

import "./RegisterEvento.vue?vue&type=style&index=0&id=eb27e62e&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb27e62e"]])

export default __exports__